import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { EmployeeService } from 'src/app/services/employee.service';
import { ImportResultEnum, ImportTypesEnum } from '../../../model/enum';

@Component({
  selector: 'app-import-errors-dialog',
  templateUrl: './import-errors-dialog.component.html',
  styleUrls: ['./import-errors-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportErrorsDialogComponent {
  constructor(private employeeService: EmployeeService) {}
  @Input() public testImport = true;
  @Input() public importType: ImportTypesEnum;

  private importResultValue: any;
  @Input()
  public get importResult(): any {
    if (!this.importResultValue) {
      return this.importResultValue;
    }
    this.importResultValue.Errors.forEach((element: any) => {
      element.Message = element.Message.replace(/<br\s*\/?><br\s*\/?>/gi, '<br>');
      return;
    });

    return this.importResultValue;
  }
  public set importResult(value: any) {
    this.importResultValue = value;
    if (value) {
      this.InitialErrorGrid();
    }
  }

  @Output() public closedEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() public completeImportEvent: EventEmitter<void> = new EventEmitter<void>();

  public visible = false;
  public successDialogVisible = false;
  public fatalDialogVisible = false;

  public get showTestImportError(): boolean {
    return this.hasError && this.testImport;
  }
  public get hasError(): boolean {
    return this.importResult && this.importResult.Errors && this.importResult.Errors.length > 0;
  }
  public get IsFatal(): boolean {
    return this.importResult && this.importResult.Outcome === ImportResultEnum[ImportResultEnum.FatalError];
  }
  public get IsError(): boolean {
    return this.importResult && this.importResult.Outcome === ImportResultEnum[ImportResultEnum.Errors];
  }
  public get IsWarning(): boolean {
    return this.importResult && this.importResult.Outcome === ImportResultEnum[ImportResultEnum.Warnings];
  }
  public get isBalanceImport(): boolean {
    return this.importType === ImportTypesEnum.Initial_Balances;
  }

  public onDialogAction(action: string): void {
    if (action === 'Complete') {
      this.completeImportEvent.emit();
    }

    this.closedEvent.emit();
  }

  private InitialErrorGrid(): void {
    if (this.importResult && this.importResult.Outcome) {
      switch (this.importResult.Outcome) {
        case ImportResultEnum[ImportResultEnum.Success]:
          this.successDialogVisible = true;
          this.reloademployee();
          break;
        case ImportResultEnum[ImportResultEnum.FatalError]:
          if (this.importResult.Errors && this.importResult.Errors.length > 0) {
            this.visible = true;
          } else {
            this.fatalDialogVisible = true;
          }

          break;
        default:
          this.visible = true;
      }
    }
  }

  private reloademployee(): void {
    if (this.importType === ImportTypesEnum.Employees) {
      this.employeeService.loadEmployees();
    }
  }
}
